module.exports = __webpack_public_path__ + "27a98319dfe43203f53a354cfc3a28ed.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/head/RamonaRamon_in_Athen.jpg
// module id = 622
// module chunks = 0